import withFlightResultsContext from '../withFlightResultsContext';
import { AlternativeFlightModal } from '../components/AlternativeFlight';

export default withFlightResultsContext(AlternativeFlightModal);
